if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) return;

        this.sectionId = this.dataset.section;
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.variantEl = this.querySelector('[data-sticky-variant]');
        this.button = this.querySelector('[data-sticky-submit]');
        this.label = this.querySelector('[data-sticky-label]');
        this.mq = window.matchMedia('(max-width: 749px)');
        this.onMq = () => this.syncVisibility();
        this.onClick = () => this.submit();
        this.mq.addEventListener('change', this.onMq);
        this.button.addEventListener('click', this.onClick);

        const submitButton = this.submitButton();
        if (submitButton) {
          this.buttonObserver = new MutationObserver(() => this.syncButton());
          this.buttonObserver.observe(submitButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled'],
            subtree: true,
            childList: true,
            characterData: true,
          });
          this.visibilityObserver = new IntersectionObserver(() => this.syncVisibility(), {
            root: null,
            rootMargin: '0px 0px -80px 0px',
            threshold: 0,
          });
          this.visibilityObserver.observe(submitButton);
        }

        if (typeof subscribe === 'function') {
          this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId !== this.sectionId) return;
            this.syncPrice();
            this.syncButton();
            if (this.variantEl && event.data.variant) {
              const title = event.data.variant.title;
              const isDefault = !title || title === 'Default Title';
              this.variantEl.hidden = isDefault;
              if (!isDefault) this.variantEl.textContent = title;
            }
          });
        }

        this.syncPrice();
        this.syncButton();
        this.syncVisibility();
      }

      disconnectedCallback() {
        this.mq?.removeEventListener('change', this.onMq);
        this.button?.removeEventListener('click', this.onClick);
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.unsubVariant?.();
        if (!document.querySelector('sticky-atc:not([hidden])')) {
          document.body.classList.remove('sticky-atc-is-visible');
        }
      }

      submitButton() {
        return document.getElementById(`product-form-${this.sectionId}`)?.querySelector('[name="add"]');
      }

      syncPrice() {
        const root = document.getElementById(`price-${this.sectionId}`);
        const price = root?.querySelector('.price');
        if (!this.priceEl || !price || root.classList.contains('hidden')) return;
        const node = price.classList.contains('price--on-sale')
          ? price.querySelector('.price-item--sale')
          : price.querySelector('.price__regular .price-item--regular');
        if (node) this.priceEl.textContent = node.textContent.trim();
      }

      syncButton() {
        const submitButton = this.submitButton();
        if (!submitButton || !this.button || !this.label) return;
        const unavailable = submitButton.hasAttribute('disabled') || submitButton.getAttribute('aria-disabled') === 'true';
        this.button.toggleAttribute('disabled', unavailable);
        const text = submitButton.querySelector('span')?.textContent?.trim();
        if (text) this.label.textContent = text;
      }

      syncVisibility() {
        const submitButton = this.submitButton();
        const mobile = this.mq.matches;
        if (!mobile || !submitButton) {
          this.hide();
          return;
        }
        const rect = submitButton.getBoundingClientRect();
        const onScreen = rect.top < window.innerHeight - 80 && rect.bottom > 0;
        if (onScreen) this.hide();
        else this.show();
      }

      show() {
        if (!this.hasAttribute('hidden')) return;
        this.removeAttribute('hidden');
        document.body.classList.add('sticky-atc-is-visible');
        document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
      }

      hide() {
        if (this.hasAttribute('hidden')) return;
        this.setAttribute('hidden', '');
        if (!document.querySelector('sticky-atc:not([hidden])')) {
          document.body.classList.remove('sticky-atc-is-visible');
        }
      }

      submit() {
        const submitButton = this.submitButton();
        if (!submitButton || submitButton.hasAttribute('disabled') || submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }
        submitButton.click();
      }
    }
  );
}
